module.exports = __webpack_public_path__ + "img/solutions2@2x.5fee7b4.png";